import { Box } from '@chakra-ui/react';
import { useMelioIntl } from '@melio/ar-domain';
import { Group, Icon, IconKey, NakedButton, Text } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import { isString } from 'lodash';

export type LineItemProps = {
  icon?: IconKey | JSX.Element;
  label: string;
  onEdit?: VoidFunction;
  isDisabled?: boolean;
};

export const LineItem = forwardRef<LineItemProps>(({ label, children, icon, onEdit, isDisabled, ...props }, ref) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Box data-component={LineItem.displayName} {...props} ref={ref}>
      <Group variant="horizontal" alignItems="flex-start" justifyContent="space-between" width="full">
        <Group variant="horizontal" spacing="s" alignItems="center">
          <MyIcon icon={icon} />
          <Group variant="vertical" spacing="xxs">
            <Text textStyle="caption1" color="neutral.darker" as="h3">
              {label}
            </Text>
            <Text textStyle="body3" as="p">
              {children}
            </Text>
          </Group>
        </Group>
        {onEdit && (
          <NakedButton
            variant="secondary"
            label={formatMessage('ar.guestPayment.activities.paymentReview.sections.buttons.edit.label')}
            data-testid="line-item-edit"
            onClick={onEdit}
            isDisabled={isDisabled}
          />
        )}
      </Group>
    </Box>
  );
});
LineItem.displayName = 'LineItem';

const MyIcon = ({ icon }: { icon: LineItemProps['icon'] }) => {
  if (isString(icon)) {
    return <Icon type={icon} />;
  }
  return icon || null;
};
